import React from 'react';
import { PureComponent } from '../../../../dispatcher/modules';
import { 
  DropDownButton as KendoDropDownButton, 
  DropDownButtonCloseEvent
} from '@progress/kendo-react-buttons';
import * as _ from 'lodash';
import { isEqual } from 'lodash';
import ReactDOM from 'react-dom';
import { PUZZLE_DROP_DOWN_PROPS } from './Types';
import classNames from 'classnames';

class PuzzleDropDownButton extends PureComponent<PUZZLE_DROP_DOWN_PROPS> {
  reference: React.RefObject<KendoDropDownButton> = React.createRef();

  static defaultProps = {
    // Pass this as a text to display as aria label (Accessibility)
    buttonAriaLabel: ''
  };

  componentDidMount(): void {
    this.setAccessibility();
  }

  componentDidUpdate = (prevProps: PUZZLE_DROP_DOWN_PROPS) => {
    if (!isEqual(prevProps, this.props)) {
      this.setAccessibility();
    }
  };

  /**
   * Drop down on close. Issue appears when drop down list is closed clicking outside of button itself. tabindex remains as -1
   * //TODO check with new kendo -v this issue might be fixed
   *
   * @param event
   */
  dropDownButtonOnClose = (event: DropDownButtonCloseEvent) => {
    event.target.element?.removeAttribute('tabindex');
  };

  /**
   * Updates dom to pass accessibility requirements
   */
  setAccessibility = () => {
    const chevronArray: any[] = this.getNodeByTagName('span');
    if (chevronArray.length) {
      chevronArray[0].setAttribute('aria-hidden', 'true');
      chevronArray[0].removeAttribute('role');
    }
    const elementsByClassName: any[] = this.getNodeByTagName('button');
    if (elementsByClassName.length) {
      if (this.props.text) {
        elementsByClassName[0].removeAttribute('aria-label');
      } else {
        elementsByClassName[0].setAttribute('aria-label', this.props.buttonAriaLabel + ' dropdownbutton');
      }
    }
  };

  /**
   * Returns node(s) by passed string (tag)
   *
   * @param tag
   */
  getNodeByTagName = (tag: string) => {
    const userButtonEl: any = ReactDOM.findDOMNode(this);
    return Array.from(userButtonEl.querySelectorAll(tag));
  };

  /**
   * @inheritDoc
   */
  render(): JSX.Element {
    const { buttonClass, reverse, iconClass } = this.props;
    const dropdownBtnProp = classNames(buttonClass, {
      'k-button-icon-text': !_.isUndefined(iconClass),
      'k-flex-row-reverse': reverse
    });
    const dropdownProps = _.omit(this.props, ['reverse']);
    const popupClass = classNames('data-preventrecorddeselect', {
      [dropdownProps?.popupSettings?.popupClass]: dropdownProps?.popupSettings?.popupClass
    });
    return (
      <KendoDropDownButton
        ref={this.reference}
        {...dropdownProps}
        popupSettings={{
          ...dropdownProps.popupSettings,
          popupClass: popupClass
        }}
        // @ts-ignore
        themeColor={dropdownProps.themeColor}
        buttonClass={dropdownBtnProp}
        onClose={this.dropDownButtonOnClose}
      />
    );
  }
}

export default PuzzleDropDownButton;
